module.exports = __webpack_public_path__ + "static/img/1256.9c21391.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1256.jpg
// module id = pddF
// module chunks = 0